
import { defineComponent } from 'vue'
import Tree from 'primevue/tree'
import { iMenuNode } from '../MenuManagement'
import { arrayToTree } from '@/helpers/commons/arrayToTreeHelper'
import menuNodesTreeDescriptor from './MenuManagementNodesTreeDescriptor.json'
export default defineComponent({
    name: 'menu-nodes-tree',
    components: {
        Tree
    },
    emits: ['selectedMenuNode', 'unselectedMenuNode', 'deleteMenuNode', 'changeWithFather', 'moveUp', 'moveDown'],
    props: {
        elements: Array,
        loading: Boolean
    },
    watch: {
        elements: {
            handler: function(element) {
                element = element.map((item) => {
                    item.label = item.name
                    item.id = item.menuId
                    item.key = item.menuId
                    return item
                })

                this.menuElements = [{ label: this.$t('common.home'), name: this.$t('common.home'), menuId: null, children: arrayToTree(element, { dataField: null, style: this.menuNodesTreeDescriptor['node-style'] }) }]
                this.expandAll()
            }
        },
        loading: {
            handler: function(l) {
                this.load = l
            }
        }
    },
    data() {
        return {
            load: false as Boolean,
            menuElements: [] as any[],
            expandedKeys: [] as any[],
            selectedMenuNode: null as iMenuNode | null,
            buttonsVisible: [],
            menuNodesTreeDescriptor: menuNodesTreeDescriptor
        }
    },
    methods: {
        expandAll() {
            for (let node of this.menuElements) {
                this.expandNode(node)
            }
            this.expandedKeys = { ...this.expandedKeys }
        },
        expandNode(node) {
            if (node.children && node.children.length) {
                this.expandedKeys[node.key] = true

                for (let child of node.children) {
                    this.expandNode(child)
                }
            }
        },
        canBeMovedUp(node: iMenuNode) {
            return node.prog !== 1 && node.menuId
        },
        canBeMovedDown(node: iMenuNode) {
            if (node.menuId === null) {
                return false
            }
            let parentNode: iMenuNode | null = null
            if (node.parentId) {
                parentNode = this.findNode(node.parentId, this.menuElements)
            } else {
                parentNode = this.menuElements[0]
            }
            return parentNode && parentNode.children && parentNode.children.length !== node.prog
        },
        findNode(menuId: any, nodes: iMenuNode[]): iMenuNode | null {
            for (let node of nodes) {
                if (node.menuId === menuId) {
                    return node
                }
                const foundNode = this.findNode(menuId, node.children)
                if (foundNode) return foundNode
            }
            return null
        },
        canBeDeleted(node: iMenuNode) {
            return !(node.children?.length > 0)
        },
        deleteMenuNode(elementID: number) {
            this.$emit('deleteMenuNode', elementID)
        },
        changeWithFather(elementID: number) {
            this.$emit('changeWithFather', elementID)
        },
        moveUp(elementID: number) {
            this.$emit('moveUp', elementID)
        },
        moveDown(elementID: number) {
            this.$emit('moveDown', elementID)
        },
        onElementSelect(event: any) {
            this.$emit('selectedMenuNode', event.value)
        },
        onNodeSelect(node: iMenuNode) {
            this.$emit('selectedMenuNode', node)
        },
        onNodeUnselect(node: iMenuNode) {
            this.$emit('unselectedMenuNode', node)
        }
    }
})
